<template>
  <div id="app">
    <v-app dark theme="dark">
      <router-view v-if="!ajaxing" />
    <div>
      <div id="loader"></div>
    </div>
    </v-app>
     
  </div>
</template>

<script>
export default {
  name: "app",
  data() {
    return {
      ajaxing: true,
    };
  },
  beforeCreate: function () {
   
    this.$store.dispatch("loginAuth").then((data) => {
      this.ajaxing = false;
    });

  },
  updated() {
    // window.setTimeout(function(){
    //   var element = document.getElementById("inspire");
    //   if(element){
    //     document.getElementById("loader").style.display = "none";
    //   }
    // },3000)
    var element = document.getElementById("inspire");
    if(element){
      document.getElementById("loader").style.display = "none";
    }
  },
  mounted: function(){
     // Load reCAPTCHA script dynamically
     this.loadRecaptcha();
  },
  methods: {
    loadRecaptcha() {
      if (!window.grecaptcha) {
        const script = document.createElement("script");
        script.src = 'https://www.google.com/recaptcha/api.js?render=6LfO6eQqAAAAABiBxoqJc5DLshut5AxJHDqkm1pS';
        script.async = true;
        script.defer = true;
        script.onload = this.onRecaptchaLoaded;
        document.head.appendChild(script);
      } else {
        this.onRecaptchaLoaded();
      }
    },
    onRecaptchaLoaded() {
      console.log("reCAPTCHA loaded successfully.");
    },
  }
};
</script> 

<style>
  .v-application {
    font-family:Lato!important;
    font-weight: 600;
  }

  #loader {
  position: absolute;
  left: 50%;
  top: 50%;
  z-index: 1;
  width: 120px;
  height: 120px;
  margin: -76px 0 0 -76px;
  border: 16px solid #f3f3f3;
  border-radius: 50%;
  border-top: 16px solid #3498db;
  -webkit-animation: spin 2s linear infinite;
  animation: spin 2s linear infinite;
  }

  @-webkit-keyframes spin {
  0% { -webkit-transform: rotate(0deg); }
  100% { -webkit-transform: rotate(360deg); }
  }

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
  }



</style>